import { DatePicker, Input } from 'cdk-radial';
import styled from 'styled-components';

export const StyledTableContainer = styled.div`
  width: 800px;
  display: flex;
  padding-bottom: 1%;
`;

export const StyledPrintCheckLabel = styled.span`
  font-size: 0.75rem;
`;

export const StyledPrintCheckValue = styled.span`
  padding: 0 20px 0 10px;
`;

export const StyledPrintCheckDialogContent = styled.div`
  display: flex;
  margin: 20px 0 20px;
  align-items: center;
`;

export const StyledPrintOrderDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const StyledPrintFailedComment = styled.p`
  align-items: center;
`;

export const StyledHeaderContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
`;

export const StyledPaymentDatePicker = styled(DatePicker)`
  width: 150px;
`;

export const StyledSelectedChecksSpan = styled.span`
  color: #60646a;
  margin: 0.5em 0.3rem 0 0;
`;

export const StyledPostingDesc = styled(Input)`
  width: 60%;
  margin-left: 40%;
`;

export const StyledToast = styled.div`
  padding-bottom: 1em;
`;
